<template>
    <BreadCrumb PageTitle="Ajouter un type un type de container" />
    <AddModalTypeContainer />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalTypeContainer from "@/components/TypeContainer/AddModalTypeContainer.vue";

export default defineComponent({
    name: "AddTypeContainerPage",
    components: {
        BreadCrumb,
        AddModalTypeContainer,
    },
});
</script>